
import axios from '../../config/axiosConfig';
import { 
    CREATE_PIPE_RECEIVE, 
    GET_PIPE_RECEIVES, 
    PIPE_RECEIVE_REQUEST, 
    DELETE_PIPE_RECEIVE, 
    UPDATE_PIPE_RECEIVE, 
    PIPE_RECEIVE_REQUEST_FAILURE, 
    GET_PIPE_RECEIVES_PAGE, 
    PIPE_RECEIVE_REQUEST_SUCCESS 
} from '../types';

export const getValidatedIncrementedVchNoPipeReceive = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/pipe-receive/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPipeReceiveWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Item,Account,Vehicle,PipeType'
      };
      return axios.get("/pipe-receive/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PIPE_RECEIVES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPipeReceives = (include) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_RECEIVE_REQUEST });
            const { auth } = getState();
            let params = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth?.user?.Customer_Id
            };
            if (include) {
                params = { ...params, include };
            }
            return axios.get('/pipe-receive/get', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_PIPE_RECEIVES, payload: response.data?.data || [] });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getPipeReceiveById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_RECEIVE_REQUEST });
    
      return axios.get(`/pipe-receive/get/${id}`).then((response) => {
        dispatch({ type: PIPE_RECEIVE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getPartyPipeBalanceInPipeReceive = (accountId) => {
  return async (dispatch, getState) => {
    try {
       const { auth } = getState();
       let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
       };
       if (accountId) {
        params = { ...params, accountId };
       }
    
      return axios.get(`/pipe-receive/get-party-pipe-balance`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error);
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const createPipeReceive = (pipeReceive) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: PIPE_RECEIVE_REQUEST });
            axios.post('/pipe-receive/add', pipeReceive,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_PIPE_RECEIVE, payload: response.data });
                    } else {
                        dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: 'Pipe Receive create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updatePipeReceive = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: PIPE_RECEIVE_REQUEST });
            return axios.put('/pipe-receive/update', { id, data }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_PIPE_RECEIVE, payload: { id, data: response.data } }, { params: { userId: auth.user?.id }});
                } else {
                    dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: 'Pipe Receive update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deletePipeReceive = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_RECEIVE_REQUEST });
            axios.delete(`/pipe-receive/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_PIPE_RECEIVE, id: id });
                    const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Item_Id', 'Receive_Pipe', 'Ends', 'Vehicle_Id', 'Pipe_Type_Id', 'Remark'].join(',');
                    const searchCols = ['Vch_No', 'Date', 'Account_Id', 'Item_Id', 'Receive_Pipe', 'Ends', 'Vehicle_Id', 'Pipe_Type_Id', 'Remark'].join(',');
                    const { inventory: { pipeReceive: { page, pageSize, search, where } = {} } } = getState();
                    dispatch(getPipeReceiveWithPagination(page, pageSize, include, search, searchCols, where, true));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RECEIVE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};